export const configUrl = {
  baseUrl: process.env.REACT_APP_BASE_URL,
  baseUrlForCoffeeQuotes: process.env.REACT_APP_BASE_URL_FOR_COFFEEQUOTES,
  baseUrlForMobileMenus: process.env.REACT_APP_BASE_URL_FOR_MOBILE_MENUS,
  coffeeCastBaseUrl: process.env.REACT_APP_BASE_URL_COFFEE_CAST,
  coffeeWebPostBaseUrl: process.env.REACT_APP_BASE_URL_COFFEE_POST,
  FreightRatesBaseUrl: process.env.REACT_APP_BASE_URL_FREIGHT_RATES,
  coffeeReportBaseUrl: process.env.REACT_APP_BASE_URL_COFFEE_REPORTS,

  coffeeCastJavaBaseUrl: process.env.REACT_APP_JAVA_BASE_URL,
  coffeeCastMediaBaseUrl: process.env.REACT_APP_JAVA_BASE_URL_MEDIA,
  coffeeCastPostBaseUrl: process.env.REACT_APP_JAVA_BASE_URL_POST
}
